<template>
    <AppBase>
        <v-card flat>
            <v-card-title class="justify-center">Trophies</v-card-title>
            <v-card-subtitle v-if="myTrophies.length === 0" class="text-center">No trophies yet! Start using MyPeeps to earn them!</v-card-subtitle>
            <v-card-text>
                <v-row>
                    <v-col v-for="(trophy, index) in myTrophies" :key="index" class="d-flex child-flex" cols="4">
                        <div class="trophy-container">
                            <div class="trophy-text text-center">{{ trophy.title }}</div>
                            <v-img :src="require(`@/assets/trophies/${trophy.id}.png`)" class="trophy-image"> </v-img>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </AppBase>
</template>

<script>
    import AppBase from '@/components/AppBase';
    import { uniqBy, sortBy } from 'lodash';
    export default {
        name: 'Trophies',
        components: { AppBase },
        data: () => ({}),
        computed: {
            myTrophies() {
                let completed = this.$store.get(`completed`);

                return sortBy(
                    uniqBy(completed, (o) => o.id),
                    'id'
                );
            }
        }
    };
</script>

<style scoped>
    .trophy-container {
        padding: 5px;
    }

    .trophy-text {
        height: 50px;
        line-height: normal;
        /* background-color: coral; */
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.8em;
        font-weight: bold;
        padding: 8px;
    }
</style>
